/** One URL/filter contract for Runs in Activity and in a resource's peek. */
export type RunHistoryFilters = {
	bucket: string;
	status: string;
	automationIds: number[];
	connectionIds: number[];
	connectorKey: string;
};

export const RUN_BUCKETS = [
	{ value: "all", label: "All" },
	{ value: "automation", label: "Automation" },
	{ value: "sync", label: "Sync" },
	{ value: "action", label: "Action" },
	{ value: "auth", label: "Auth" },
];
export const RUN_STATUSES = [
	{ value: "running", label: "Running" },
	{ value: "completed", label: "Completed" },
	{ value: "failed", label: "Failed" },
	{ value: "pending", label: "Pending" },
	{ value: "claimed", label: "Claimed" },
	{ value: "cancelled", label: "Cancelled" },
	{ value: "timeout", label: "Timed out" },
];

function ids(value: unknown): number[] {
	return [
		...new Set(
			String(value ?? "")
				.split(",")
				.filter((id) => /^[1-9]\d*$/.test(id))
				.map(Number)
				.filter(Number.isSafeInteger),
		),
	];
}

export function parseRunHistoryFilters(
	search: Record<string, unknown>,
): RunHistoryFilters {
	return {
		bucket: RUN_BUCKETS.some((option) => option.value === search.run_type)
			? String(search.run_type)
			: search.tab === "automations"
				? "automation"
				: "all",
		status: RUN_STATUSES.some((option) => option.value === search.run_status)
			? String(search.run_status)
			: "all",
		automationIds: ids(search.automation_ids),
		connectionIds: ids(search.connection_ids),
		connectorKey:
			typeof search.connector_key === "string"
				? search.connector_key.trim()
				: "",
	};
}

export function runHistorySearch(
	filters: Partial<RunHistoryFilters>,
): Record<string, string | undefined> {
	return {
		tab: "runs",
		run_type:
			filters.bucket && filters.bucket !== "all" ? filters.bucket : undefined,
		run_status:
			filters.status && filters.status !== "all" ? filters.status : undefined,
		automation_ids: filters.automationIds?.length
			? filters.automationIds.join(",")
			: undefined,
		connection_ids: filters.connectionIds?.length
			? filters.connectionIds.join(",")
			: undefined,
		connector_key: filters.connectorKey || undefined,
	};
}

export function runHistoryHref(
	owner: string,
	filters: Partial<RunHistoryFilters>,
): string {
	const search = new URLSearchParams();
	for (const [key, value] of Object.entries(runHistorySearch(filters)))
		if (value) search.set(key, value);
	return `/${owner}?${search}`;
}
